import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconError = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 35 35'>
    <title>{t('Error')}</title>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M19.5 34.5c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15m0-32.5C9.85 2 2 9.85 2 19.5S9.85 37 19.5 37 37 29.15 37 19.5 29.15 2 19.5 2m5.958 11.388a1.251 1.251 0 0 0-1.767-.022l-4.176 4.078-4.132-4.131a1.25 1.25 0 0 0-1.767 1.768l4.345 4.345c-.002.023-.014.043-.014.067 0 .02.011.039.011.06l-4.395 4.291a1.25 1.25 0 0 0 1.746 1.79l4.177-4.077 4.13 4.13a1.25 1.25 0 0 0 1.767-1.768l-4.343-4.345c0-.024.012-.044.013-.066 0-.021-.011-.04-.012-.061l4.395-4.291a1.249 1.249 0 0 0 .022-1.768'
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconError)
